import { documentTypesOptions } from '@celerofinancas/core-ts';
import { FinancialRecordStatusInterface } from '@celerofinancas/ui-cash-flow';

/**
 * Financial record status enum
 */
export enum FINANCIAL_RECORD_STATUS {
  other = 0,
  scheduled = 1,
  document = 2,
  not_document = 3,
  late_paid = 4,
  late_not_paid = 5,
  pending = 6,
  done = 7,
  not_done = 8,
  is_review = 9,
  is_partially_classified = 10,
}

/**
 * Financial record status map options
 */
export const financialRecordStatusOptions = new Map([
  [FINANCIAL_RECORD_STATUS.late_paid, 'Atrasado'],
  [FINANCIAL_RECORD_STATUS.late_not_paid, 'Atrasado'],
  [FINANCIAL_RECORD_STATUS.done, 'Realizado'],
]);

/**
 * A map to financial record status on font icon
 */
export const financialRecordStatusIcons = new Map([
  [FINANCIAL_RECORD_STATUS.late_paid, 'cds-icon-filled-alert-triangle c-danger-400'],
  [FINANCIAL_RECORD_STATUS.late_not_paid, 'cds-icon-filled-alert-triangle c-danger-400'],
  [FINANCIAL_RECORD_STATUS.done, 'cds-icon-filled-check c-success'],
]);

/**
 * Status default model
 */
export class Status implements FinancialRecordStatusInterface {
  /**
   * Get humanized name for a status
   *
   * @param index Status index
   *
   * @returns humanized status name
   */
  public getName(index: FINANCIAL_RECORD_STATUS): string {
    return financialRecordStatusOptions.get(index);
  }

  /**
   * Get key name for a status
   *
   * @param index Status index
   *
   * @returns status key name
   */
  public getCodeName(index: FINANCIAL_RECORD_STATUS): string {
    return FINANCIAL_RECORD_STATUS[index];
  }

  /**
   * Get icon name for a status
   *
   * @param index Status index
   *
   * @returns status icon name
   */
  public getIcon(index: FINANCIAL_RECORD_STATUS): string {
    return financialRecordStatusIcons.get(index);
  }

  /**
   * List a financial records status
   *
   * @param financialRecord Financial Record Object
   *
   * @returns a list of status number
   */
  public statusList(financialRecord: any): FINANCIAL_RECORD_STATUS[] {
    const list = [];

    if (financialRecord.is_late_paid) {
      list.push(FINANCIAL_RECORD_STATUS.late_paid);
    }

    if (financialRecord.is_late) {
      list.push(FINANCIAL_RECORD_STATUS.late_not_paid);
    }

    if (financialRecord.paid_at) {
      list.push(FINANCIAL_RECORD_STATUS.done);
    }

    return this.orderListByIconColor(list);
  }

  /**
   * Order the list by icon color
   * Colored status should be last in array
   *
   * @param list List of status
   */
  private orderListByIconColor(list: FINANCIAL_RECORD_STATUS[]): FINANCIAL_RECORD_STATUS[] {
    const coloredStatus: any[] = [];
    const notColoredStatus: any[] = [];
    list.forEach((status) =>
      financialRecordStatusIcons.get(status).includes('c-icon-medium')
        ? notColoredStatus.push(status)
        : coloredStatus.push(status),
    );
    return [...notColoredStatus, ...coloredStatus];
  }

  /**
   * Returns a list of financial records document types in use
   *
   * @param document_types From Financial Record
   *
   * @returns A list of status number
   */
  public typesList({ document_types }: any): string[] {
    const list: string[] = [];

    if (document_types) {
      document_types.forEach((code: any) => list.push(documentTypesOptions.get(code)));
    }

    return list;
  }
}
